export * from './__generated__/getDashboardEmployee.generated';
export * from './__generated__/getDashboardEmployeeAlert.generated';
